import React from 'react';
import { Switch, Route } from 'react-router-dom';
import SignupPage from 'shared/components/authPages/signup';
import LoginPage from 'shared/components/authPages/login';
import ForgotPasswordPage from 'shared/components/authPages/forgot';
import Bartender from 'shared/components/bartender';
import App from 'shared/components/app';
import Product from 'shared/components/product';
import Category from 'shared/components/category';
import SearchResults from 'shared/components/category/searchResults';
import CategoryGroup from 'shared/components/categoryGroup';
import CheckoutPage from 'shared/components/checkoutPage';
import OrderStatus from 'shared/components/orderTracking/status';
import OrderTip from 'shared/components/orderTracking/tip';
import Home from 'shared/components/home';
import Account from 'shared/components/account';
import ContactPreferences from 'shared/components/contactPreferences';
import OrderHistory from 'shared/components/orderHistory';
import OrderHistoryOrder from 'shared/components/orderHistory/order';
import SharePage from 'shared/components/sharePage';
import Brands from 'shared/components/brands';
import BrandPage from 'shared/components/brands/brand';
import Gifting from 'shared/components/gifting';
import SubstitutionsPage from 'shared/components/substitutions';

const Routes = props => {
  return (
    <Switch>
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/forgot-password" component={ForgotPasswordPage} />
      <Route exact path="/signup" component={SignupPage} />
      <Route exact path="/signup/:promo" component={SignupPage} />
      <Route exact path="/bartenders" component={Bartender} />
      <Route exact path="/checkout" component={CheckoutPage} />
      <Route exact path="/substitution/:orderId*" component={SubstitutionsPage} />
      <Route exact path="/" component={Home} />
      <Route>
        <App>
          <Switch>
            <Route exact path="/gifting" component={Gifting} pageName="Gifting" />
            <Route exact path="/account" component={Account} pageName="Account" />
            <Route exact path="/contact-preferences" component={ContactPreferences} pageName="Contact Preferences" />
            <Route exact path="/orders" component={OrderHistory} pageName="Order History" />
            <Route exact path="/orders/:id" component={OrderHistoryOrder} pageName="Order History Order" />
            <Route exact path="/share" component={SharePage} pageName="Share Page" />
            <Route exact path="/brands" component={Brands} pageName="Brand Index" />
            <Route exact path="/brands/:brandname" component={BrandPage} pageName="Brand Page" />
            <Route exact path="/tracking" component={OrderStatus} pageName="Order Tracking" />
            <Route exact path="/tracking/:order_id" component={OrderStatus} pageName="Order Tracking" />
            <Route exact path="/tip/:id" component={OrderTip} pageName="Tip" />
            <Route exact path="/wine" component={CategoryGroup} pageName="Wine" />
            <Route exact path="/spirits" component={CategoryGroup} pageName="Spirits" />
            <Route exact path="/more" component={CategoryGroup} pageName="More" />
            <Route exact path="/search/:searchQuery" component={SearchResults} pageName="Search Page" />
            <Route exact path="/**/:sku([A-Za-z]{2,3}-[A-Za-z0-9]{1,}-[A-Za-z0-9]{1,})" component={Product} pageName="Product Page" />
            <Route exact path="/:category/:name" component={CategoryGroup} pageName="Category Group" />
            <Route exact path="/:category" component={Category} pageName="Category Page" />
          </Switch>
        </App>
      </Route>
    </Switch>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./client/routes.js